import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ProductListItemDto } from './ProductListItemDto'
/**
* Class ShowcaseProductCollectionPreviewDto
*  Превью подборки для блоков на главной: мета + урезанный видимый состав
*/
export class ShowcaseProductCollectionPreviewDto extends ActiveModel {

  /**
  * id
  * Идентификатор подборки  */
  @ActiveField(0)
  id: number = 0


/**
  * slug
  * Глобальный ЧПУ; уникален среди неудалённых. Пустой при записи нормализуется из Name.<br>
  */
  @ActiveField('')
  slug: string = ''


/**
  * name
  * Название подборки.<br>
  */
  @ActiveField('')
  name: string = ''


/**
  * description
  * Описание (опционально).<br>
  */
  @ActiveField()
  description?: null | string


  /**
  * order
  * Порядковый номер среди подборок (глобальный).<br>  */
  @ActiveField(0)
  order: number = 0


/**
  * imagesIds
  * Идентификаторы изображений галереи в порядке Domain.Entities.ProductCollections.ProductCollectionImage.Order.<br>Первое — обложка.<br>  */
  @ActiveField({
    setter(model: ShowcaseProductCollectionPreviewDto, prop: string, value: Array<string>, receiver?: ShowcaseProductCollectionPreviewDto ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => String(v)) : value,
        
        receiver)
    }
  })
  imagesIds: Array<string> = []


/**
  * @property items
  * Видимые карточки товаров (после разрешения состава подборки)<br>  */
  @ActiveField({
    factory: [ProductListItemDto, () => []]
  })
  items: Array<ProductListItemDto> = []
}
